"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "fluffy--Wrapper",
  componentId: "fluffy--eyoi51"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    display: flex;\n    background: rgba(85, 86, 90, 0.5);\n    overflow: auto;\n    padding: 4px 15px;\n    flex-direction: row;\n    left: 50%;\n    bottom: 15px;\n    transform: translateX(-50%);\n    max-height: 75px;\n    min-height: 75px;\n    max-width: ", ";\n"], ["\n    position: absolute;\n    display: flex;\n    background: rgba(85, 86, 90, 0.5);\n    overflow: auto;\n    padding: 4px 15px;\n    flex-direction: row;\n    left: 50%;\n    bottom: 15px;\n    transform: translateX(-50%);\n    max-height: 75px;\n    min-height: 75px;\n    max-width: ", ";\n"])), function (_a) {
  var $width = _a.$width;
  return $width;
});
exports.Wrapper = Wrapper;
var templateObject_1;